import React, { createContext, useState, useEffect, useContext, useRef } from 'react';
import api from '../services/api'
import { format, parseISO } from 'date-fns'
import * as qs from 'qs';

const EventContext = createContext({});

export const EventProvider = ({ children }) => {
    const [events, setEvents] = useState([]);
    const [update, setUpdate] = useState(true);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });
    const total = useRef(0)

    async function getEvents(page = 1, pageSize = 10, reset = true) {
        let query = qs.stringify({
            filters: {
                deleted: {
                    $eq: false
                },
            },
            pagination: {
                page: page,
                pageSize: pageSize
            },
            fields: ['name', 'city', 'count_subscribers', 'max_subscribers', 'date_initial', 'end_subscription', 'isActive', 'counter_hostings', 'typeForm'],
            populate: {
                plans: {
                    populate: '*',
                },
                hostings: {
                    populate: '*',
                },
                collectors: {
                    populate: '*'
                }
            },
            sort: ['createdAt:desc'],
            encodeValuesOnly: true,

        })
        try {
            const allEvents = await api.get(`/events?${query}`)
            if (allEvents.status === 200) {
                allEvents.data.data.map((event) => {
                    event.attributes.end_subscription = format(parseISO(event.attributes.end_subscription), 'dd/MM/yy')
                    event.attributes.date_initial = format(parseISO(event.attributes.date_initial), 'dd/MM/yy')
                    event.attributes.count_subscribers = `${event.attributes.count_subscribers}`
                    event.attributes.isActive = event.attributes.isActive === true ? 'Aberto' : 'Encerrado'
                    return
                })
                setPagination({
                    page: allEvents.data.meta.pagination.page, pageSize: allEvents.data.meta.pagination.pageSize, total: allEvents.data.meta.pagination.total, pageCount: allEvents.data.meta.pagination.pageCount
                })
                total.current = allEvents.data.meta.pagination.total
                reset ? setEvents(allEvents.data.data) : setEvents(prev => [...prev, ...allEvents.data.data])
            }
        } catch (error) {
            return error
        }
    }


    async function deleteEvent(eventId) {
        try {
            const event = await api.put('/events/' + eventId, { data: { deleted: true } })
            if (event.status === 200) {
                setEvents(events.filter((value, index, arr) => { return value.id !== eventId }))
            }
        } catch (error) {
            return error
        }
    }

    useEffect(() => {
        if (update) {
            getEvents()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [update])

    return (
        <EventContext.Provider
            value={{ events, deleteEvent, setUpdate, getEvents, total, pagination, setPagination }}>
            {children}
        </EventContext.Provider>
    );
};

export function useEvent() {
    const context = useContext(EventContext);

    return context;
}
export default EventContext;